import { render, staticRenderFns } from "./club-team.vue?vue&type=template&id=8493396c&scoped=true"
import script from "./club-team.vue?vue&type=script&lang=js"
export * from "./club-team.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8493396c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8493396c')) {
      api.createRecord('8493396c', component.options)
    } else {
      api.reload('8493396c', component.options)
    }
    module.hot.accept("./club-team.vue?vue&type=template&id=8493396c&scoped=true", function () {
      api.rerender('8493396c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/club-info/club-team.vue"
export default component.exports